import { Link } from 'react-router-dom'
import { AlertTriangle } from 'lucide-react'
import { routes } from '@/shared/constants'
import { usePendingBillingsCount } from '../hooks/usePendingBillingsCount'

/**
 * Aviso de la barra superior: si el usuario tiene facturas pendientes de pago
 * en alguno de sus negocios, muestra un indicador ámbar que enlaza a
 * Facturación. Sin facturas pendientes (o mientras carga) no renderiza nada,
 * para no ocupar la barra ni provocar un parpadeo.
 */
export function PendingBillingsAlert() {
  const { count, loading } = usePendingBillingsCount()

  if (loading || count === 0) return null

  const label =
    count === 1
      ? 'Tienes una factura pendiente de pago'
      : `Tienes ${count} facturas pendientes de pago`

  return (
    <Link
      to={routes.app.billing.list}
      aria-label={label}
      title={label}
      className="flex h-[38px] items-center gap-1.5 rounded-lg border border-amber-300 bg-amber-50 px-2.5 text-amber-700 transition-colors hover:border-amber-400 hover:bg-amber-100"
    >
      <AlertTriangle className="h-[18px] w-[18px] shrink-0" />
      <span className="hidden text-xs font-semibold sm:inline">
        {count === 1 ? 'Factura pendiente' : `${count} facturas pendientes`}
      </span>
    </Link>
  )
}
